export default function useScrollTo() {
  function scrollToTop(delay: number = 50) {
    scrollToYCoordinate(0, delay);
  }
  function scrollToYCoordinate(yCoord: number, delay: number = 50) {
    document.documentElement.style.scrollBehavior = "auto";
    setTimeout(() => window.scrollTo(0, yCoord), delay);
    setTimeout(() => (document.documentElement.style.scrollBehavior = "smooth"), delay);
  }
  function scrollToRef(ref: React.RefObject<HTMLElement | null>, delay: number = 50) {
    if (ref.current) {
      scrollToYCoordinate(ref.current.offsetTop, delay);
    } else {
      console.error("scrollToRef Error: ref.current was not defined.");
    }
  }
  return {
    /**
     * Scrolls the browser window to the top of the page.  This makes it so that the scroll "Snaps"
     * to the top of the page instead of animating as would occur by default.
     *
     * Alias for scrollToYCoordinate that automatically sets the Y coordinate as 0.
     *
     * @param {number} delay Optional. The delay to scroll in milliseconds.  Should be a low number.
     */
    scrollToTop: scrollToTop,
    /**
     * Scrolls the browser window to the specified Y coordinate.  This makes it so that the scroll "Snaps"
     * to the  the specified position instead of animating as would occur by default.
     *
     * @param {number} yCoord The Y coordinate to scroll to.
     * @param {number} delay Optional. The delay to scroll in milliseconds.  Should be a low number.
     */
    scrollToYCoordinate: scrollToYCoordinate,
    /**
     * Scrolls the browser window to the top of the specified HTML element.  This makes it so that the
     * scroll "Snaps" to the specified position instead of animating as would occur by default.
     *
     * Alias for scrollToYCoordinate that automatically sets the Y coordinate to the location of the element.
     *
     * @param {number} yCoord The Y coordinate to scroll to.
     * @param {number} delay Optional. The delay to scroll in milliseconds.  Should be a low number.
     */
    scrollToRef: scrollToRef,
  };
}
